import styled from 'styled-components';
import { modeColor } from '../../styles';
import { Box } from '../Core';
import { Icon } from '../Icons';
import type { NotificationSizes } from './types';

const defaultNotificationShade = '040';

export const NotificationWrapper = styled(Box)<{ size: NotificationSizes }>`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex: 1;
  min-width: min(20rem, 100%);
  color: ${({ theme }) => theme.colorTextImportant};

  ${({ theme, size }) => {
    const bgNormal = modeColor(theme, theme.colors.gray.main, theme.colors.gray[defaultNotificationShade]);
    const bgHover = modeColor(theme, theme.colors.gray['020'], theme.colors.gray['050']);
    return `
    gap: ${theme.spacing8}px;
    padding: ${size === 'Default' ? theme.spacing16 : theme.spacing8}px;
    background: ${bgNormal};
    font-size: ${theme.fontSizeDefault}rem;
    transition: background-color 0.2s ease-in-out;
    &:hover {
      background: ${bgHover};
    }
  `;
  }}

  ${Icon} {
    cursor: pointer;
    &:hover {
      color: ${({ theme }) => theme.colorTextDefault};
    }
  }
`;
